import axios from 'axios';

const API_BASE = '/api/time-entries';

export const timeService = {
  getAll: async (params = {}) => {
    const response = await axios.get(API_BASE, { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}`);
    return response.data;
  },

  getAuditLog: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}/audit-log`);
    return response.data;
  },

  create: async (data) => {
    const response = await axios.post(API_BASE, data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axios.put(`${API_BASE}/${id}`, data);
    return response.data;
  },

  /** Resolve lat/long to location text (named_locations + geocode). which: 'in' | 'out' | 'both' */
  resolveLocation: async (id, which = 'both') => {
    const response = await axios.post(`${API_BASE}/${id}/resolve-location`, { which });
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`${API_BASE}/${id}`);
    return response.data;
  },

  /** Kiosk punch by PIN (no auth). Requires location + device_name in data. */
  kioskPunch: async (data) => {
    const response = await axios.post(`${API_BASE}/kiosk-punch`, data);
    return response.data;
  },

  /** Kiosk timecard by PIN (no auth). Returns last 14 days for that employee. */
  kioskTimecard: async (pin) => {
    const response = await axios.get(`${API_BASE}/kiosk-timecard`, { params: { pin } });
    return response.data;
  },

  kioskOpenPunch: async (pin) => {
    const response = await axios.get(`${API_BASE}/kiosk-open-punch`, { params: { pin } });
    return response.data;
  },

  kioskTasks: async () => {
    const response = await axios.get(`${API_BASE}/kiosk-tasks`);
    return response.data;
  },

  kioskTaskContext: async (pin) => {
    const response = await axios.get(`${API_BASE}/kiosk-task-context`, { params: { pin } });
    return response.data;
  }
};
